type ContentfulRichTextNode = {
  nodeType?: string;
  value?: string;
  content?: ContentfulRichTextNode[];
};

const richTextToPlainText = (node?: ContentfulRichTextNode | null): string => {
  if (!node) return '';

  if (node.nodeType === 'text') {
    return node.value ?? '';
  }

  return node.content?.map(richTextToPlainText).join('').replace(/\s+/g, ' ').trim() ?? '';
};

export default richTextToPlainText;
